import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

interface LoaderProps {
  bg_color?: string;
}

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Loader = styled.div<LoaderProps>`
  border: 4px solid ${(props) => (!!props.bg_color ? props.bg_color : 'rgba(0, 0, 0, 0.1)')};
  border-radius: 50%;
  border-top: 4px solid var(--primary-green);
  width: 22px;
  height: 22px;
  animation: ${spin} 1s linear infinite;
`;
